import { QueryClient } from "@tanstack/react-query";

import { notifyError, notifySuccess } from "@components/notifications/notifications";

/** Every report's review items, or one report's when `reportId` is given. */
export const invalidateReviewItems = (queryClient: QueryClient, reportId?: string) =>
  queryClient.invalidateQueries({
    queryKey: reportId ? ["getReportReviewItems", { reportId }] : ["getReportReviewItems"],
  });

/** Reviewer list plus everything derived from it: the Review filter counts and per-report review state. */
export const invalidateReportReviewers = (queryClient: QueryClient) =>
  Promise.all(
    ["getReportReviewers", "reportReviewCounts", "getReportsWithReviewState"].map((key) =>
      queryClient.invalidateQueries({ queryKey: [key] }),
    ),
  );

type MutationResult = { success?: boolean | null; message?: string | null } | null | undefined;

/** Toasts the server's verdict on a review mutation; true when it succeeded. */
export const settleReviewMutation = (
  result: MutationResult,
  toasts: { failure: string; success?: string },
): boolean => {
  if (!result?.success) {
    notifyError(result?.message || toasts.failure);
    return false;
  }
  if (toasts.success) notifySuccess(result.message || toasts.success);
  return true;
};
